import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { ApiPermissions, getEmployeePermissions } from 'src/api/permissions';

import { ThunkConfig } from '../types';

export const fetchUserPermissions = createAsyncThunk<
  ApiPermissions,
  void,
  ThunkConfig<string>
>('user/fetchUserPermissions', async (_, { rejectWithValue }) => {
  try {
    const response = await getEmployeePermissions();

    return response;
  } catch (e) {
    return rejectWithValue((e as AxiosError).message);
  }
});
